import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbDecorator } from "abreact/form/AbDecorator";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbSize, AbSizeContext } from "abreact/misc/AbSize";
import * as React from "react";
export function AbDecoratorBar(props) {
  return /*#__PURE__*/React.createElement("div", ReactUtils.componentProps("ab-decorator-bar", props), /*#__PURE__*/React.createElement(AbSizeContext.Provider, {
    value: AbSize.SMALL
  }, props.decorators.map((decorator, index) => {
    return /*#__PURE__*/React.createElement(AbDecorator, _extends({
      key: decorator.id || index
    }, decorator));
  })));
}
//# sourceMappingURL=AbDecoratorBar.js.map
